import Urls from "../../constants/urls";
import bath1 from "./imgs/bath1.jpg";
import bath2 from "./imgs/bath1.jpg";
import bedroom1 from "./imgs/bedroom1.jpg";
import bedroom2 from "./imgs/bedroom2.jpg";
import living from "./imgs/living.jpg";
import kitchen from "./imgs/Kitchen.jpg";
import entrance from "./imgs/entrance.jpg";

export const bath1Hotspots = [
  {
    type: "arrow",
    zPosition: 1,
    yPosition: -55,
    xPosition: 10,
    xRotation: -90,
    yRotation: 100,
    zRotation: 258,
    radius: 4,
    link: Urls.jamesHouse.bedroom1.path,
  },

];

export const bath2Hotspots = [
  {
    type: "arrow",
    zPosition: 7,
    yPosition: -45,
    xPosition: 15,
    xRotation: -90,
    yRotation: 100,
    zRotation: 258,
    radius: 4,
    link: Urls.jamesHouse.entrance.path,
  },
];

export const bedroom1Hotspots = [
  {
    type: "arrow",
    xPosition: -85,
    yPosition: -48,
    zPosition: -70,
    xRotation: -95,
    yRotation: -175,
    zRotation: 0,
    radius: 6,
    link: Urls.jamesHouse.living.path,
  },
  {
    type: "arrow",
    xPosition: -65,
    yPosition: -45,
    zPosition: 92,
    xRotation: -85,
    yRotation: -175,
    zRotation: 90,
    radius: 6,
    link: Urls.jamesHouse.bath1.path,
  }
];

export const bedroom2Hotspots = [
  {
    type: "arrow",
    xPosition: -80,
    yPosition: -45,
    zPosition: -45,
    xRotation: -100,
    yRotation: -170,
    zRotation: -100,
    radius: 6,
    link: Urls.jamesHouse.entrance.path,
  },
  {
    type: "arrow",
    xPosition: -95,
    yPosition: -45,
    zPosition: -33,
    xRotation: -100,
    yRotation: -170,
    zRotation: -10,
    radius: 6,
    link: Urls.jamesHouse.kitchen.path,
  }
];

export const entranceHotspots = [
  {
    type: "spot",
    zPosition: -124,
    yPosition: -44,
    xPosition: -26,
    xRotation: -93,
    yRotation: -10,
    zRotation: 140,
    radius: 7,
    link: Urls.jamesHouse.kitchen.path,
  },
  {
    type: "arrow",
    zPosition: -124,
    yPosition: -44,
    xPosition: -7,
    xRotation: -93,
    yRotation: -140,
    zRotation: 140,
    radius: 7,
    link: Urls.jamesHouse.bath2.path,
  }
];

export const kitchenHotspots = [
  {
    type: "arrow",
    zPosition: -93,
    yPosition: -50,
    xPosition: 48,
    xRotation: -90,
    yRotation: 70,
    zRotation: 350,
    radius: 7,
    link: Urls.jamesHouse.bedroom1.path,
  },
  {
    type: "spot",
    zPosition: -50,
    yPosition: -50,
    xPosition: 10,
    xRotation: -90,
    yRotation: 70,
    zRotation: 289,
    radius: 6,
    link: Urls.jamesHouse.living.path,
  },
  {
    type: "arrow",
    xPosition: -5,
    yPosition: -45,
    zPosition: 65,
    xRotation: -100,
    yRotation: -170,
    zRotation: 95,
    radius: 6,
    link: Urls.jamesHouse.bedroom2.path,
  }
];

export const livingHotspots = [
  {
    type: "spot",
    xPosition: 100,
    yPosition: -60,
    zPosition: 4,
    xRotation: -90,
    yRotation: 30,
    zRotation: 240,
    radius: 8,
    link: Urls.jamesHouse.kitchen.path,
  },
  {
    type: "arrow",
    xPosition: 155,
    yPosition: -70,
    zPosition: -85,
    xRotation: -90,
    yRotation: -30,
    zRotation: 35,
    radius: 8.5,
    link: Urls.jamesHouse.entrance.path,
  },
  {
    type: "spot",
    xPosition: -56,
    yPosition: -70,
    zPosition: -85,
    xRotation: -90,
    yRotation: -50,
    zRotation: 150,
    radius: 8,
    link: Urls.jamesHouse.bedroom1.path,
  }
];

export const rooms = [
  {
    name: "Bathroom 1",
    img: bath1,
    route: Urls.jamesHouse.bath1,
    yRotation: 360,
  },
  {
    name: "Bathroom 2",
    img: bath2,
    route: Urls.jamesHouse.bath2,
    yRotation: 90,
  },
  {
    name: "Kitchen",
    img: kitchen,
    route: Urls.jamesHouse.kitchen,
    yRotation: 90,
  },
  {
    name: "Bedroom 1",
    img: bedroom1,
    route: Urls.jamesHouse.bedroom1,
    yRotation: 90,
  },
  {
    name: "Bedroom 2",
    img: bedroom2,
    route: Urls.jamesHouse.bedroom2,
    yRotation: 90,
  },
  {
    name: "Entrance",
    img: entrance,
    route: Urls.jamesHouse.entrance,
    yRotation: 90,
  },
  {
    name: "Living room",
    img: living,
    route: Urls.jamesHouse.living,
    yRotation: 90,
  },

];
